import { BookOpenText, CalendarCheck, Fuel, Gauge, Download, Lock } from "lucide-react";
import { toast } from "sonner";
import api from "../lib/api";
import { Card, CardContent } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Badge } from "../components/ui/badge";

async function downloadCsv(path, filename) {
  try {
    const res = await api.get(path, { responseType: "blob" });
    const url = URL.createObjectURL(res.data);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(url);
    toast.success("Laporan dimuat turun");
  } catch {
    toast.error("Gagal memuat turun laporan");
  }
}

const REPORTS = [
  {
    icon: BookOpenText, title: "Laporan Log Perjalanan", badge: "Lampiran C4",
    desc: "Rekod penuh perjalanan: odometer, jarak, bahan api dan kadar Km/L setiap trip. Sesuai untuk audit tahunan.",
    action: () => downloadCsv("/reports/trips", "laporan_log_perjalanan.csv"),
    testId: "report-trips-btn",
  },
  {
    icon: CalendarCheck, title: "Laporan Tempahan", badge: "CSV",
    desc: "Senarai semua permohonan tempahan kenderaan beserta status kelulusan, kenderaan ditugaskan dan staf.",
    action: () => downloadCsv("/reports/bookings", "laporan_tempahan.csv"),
    testId: "report-bookings-btn",
  },
  {
    icon: Fuel, title: "Laporan Kos Bahan Api", badge: "Akan Datang",
    desc: "Analisis kos bahan api mengikut kenderaan, staf dan jabatan dengan perbandingan bulanan.",
    disabled: true, testId: "report-fuel-btn",
  },
  {
    icon: Gauge, title: "Laporan Penggunaan Fleet", badge: "Akan Datang",
    desc: "Kadar penggunaan setiap kenderaan, waktu puncak dan cadangan pengoptimuman saiz fleet.",
    disabled: true, testId: "report-utilization-btn",
  },
];

export default function ReportsPage() {
  return (
    <div className="space-y-6 fade-up" data-testid="reports-page">
      <div>
        <h1 className="text-2xl font-bold tracking-tight">Pusat Laporan</h1>
        <p className="text-sm text-muted-foreground mt-1">Jana dan muat turun laporan rasmi untuk tujuan audit dan pemantauan.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-5xl">
        {REPORTS.map((r) => (
          <Card key={r.title} className={`border-slate-200 shadow-sm rounded-xl ${r.disabled ? "opacity-70" : "stat-card"}`}>
            <CardContent className="p-6">
              <div className="flex items-start justify-between">
                <div className="h-12 w-12 rounded-xl bg-indigo-50 text-[#10056E] flex items-center justify-center">
                  <r.icon className="h-6 w-6" />
                </div>
                <Badge variant="secondary" className="text-[10px]">{r.badge}</Badge>
              </div>
              <h2 className="text-base font-semibold mt-4">{r.title}</h2>
              <p className="text-sm text-muted-foreground mt-1.5 leading-relaxed">{r.desc}</p>
              <Button
                className={`mt-5 ${r.disabled ? "" : "bg-[#10056E] hover:bg-[#2a17a8]"}`}
                variant={r.disabled ? "outline" : "default"}
                disabled={r.disabled}
                onClick={r.action}
                data-testid={r.testId}
              >
                {r.disabled ? <Lock className="h-4 w-4 mr-2" /> : <Download className="h-4 w-4 mr-2" />}
                {r.disabled ? "Akan Datang" : "Muat Turun CSV"}
              </Button>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}
